import {
  jb_facts_css_default
} from "./chunk.XF7RQA2J.js";
import {
  er,
  ke as ke2,
  tr
} from "./chunk.CV2QA46K.js";
import {
  ae
} from "./chunk.6PQ7B7BC.js";
import {
  Spaceable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.UK6KU6OP.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  awaitForEach,
  isPartiallyInViewPort
} from "./chunk.NKAUZW5M.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n,
  r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-facts/jb-facts.ts
var JbFacts = class extends Spaceable(r) {
  constructor() {
    super(...arguments);
    this.headlineStyle = "h2";
    this._scrollHandler = () => {
      this._fadeInIfInViewport(this);
    };
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.enableFadeIn) {
      document.addEventListener("scroll", this._scrollHandler, true);
    }
  }
  disconnectedCallback() {
    document.removeEventListener("scroll", this._scrollHandler, true);
    super.disconnectedCallback();
  }
  firstUpdated() {
    if (this.enableFadeIn) {
      setTimeout(() => {
        this._fadeInIfInViewport(this);
      }, 0);
    } else {
      this._skipFadeIn();
    }
  }
  _fadeInIfInViewport(element) {
    if (isPartiallyInViewPort(element, 250)) {
      this._startFadeInAnimation().then(() => {
        document.removeEventListener("scroll", this._scrollHandler, true);
      });
    }
  }
  _getCols() {
    if (this.intranetStyle) {
      return this.columns <= 2 ? this.columns : 2;
    }
    return this.columns;
  }
  _getContentSpacingProperties() {
    const cols = { 1: 8, 2: 8, 3: 10 }[this._getCols()] || 8;
    const align = "center";
    const type = "focus";
    return { align, colsMdUp: cols, type, grid: "legacy" };
  }
  _headlineTag() {
    return er`${tr(this.headlineStyle || "h2")}`;
  }
  _skipFadeIn() {
    this._facts.forEach((fact) => {
      fact.classList.add("show");
    });
  }
  async _startFadeInAnimation() {
    setTimeout(async () => {
      await awaitForEach(this._facts, async (fact) => {
        fact.classList.add("show");
        await new Promise((p) => setTimeout(p, 50));
      });
    }, 0);
  }
  _tracking(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "facts"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return ke`
      <section
        class=${Rt({
      ["cols-" + this._getCols()]: true
    })}
        part="facts"
      >
        ${this.headline ? ke2`<header><${this._headlineTag()}>${this.headline}</${this._headlineTag()}></header>` : D}
        <div class="container">
          ${this.items.map(
      (item) => ke`
              <div class="fact">
                <div class="content">
                  <p class="title">${item.title}</p>
                  <jb-richtext
                    @jb-link:clicked=${this._tracking}
                    size="small"
                    >${ae(item.content)}</jb-richtext
                  >
                </div>
              </div>
            `
    )}
        </div>
      </section>
    `;
  }
};
JbFacts.styles = [reset_css_default, jb_facts_css_default];
__decorateClass([
  n({ type: Number })
], JbFacts.prototype, "columns", 2);
__decorateClass([
  n({ type: Boolean })
], JbFacts.prototype, "enableFadeIn", 2);
__decorateClass([
  n()
], JbFacts.prototype, "headline", 2);
__decorateClass([
  n()
], JbFacts.prototype, "headlineStyle", 2);
__decorateClass([
  n({ type: Boolean })
], JbFacts.prototype, "intranetStyle", 2);
__decorateClass([
  n({ type: Array })
], JbFacts.prototype, "items", 2);
__decorateClass([
  r2(".fact")
], JbFacts.prototype, "_facts", 2);
JbFacts = __decorateClass([
  customElement("jb-facts")
], JbFacts);

export {
  JbFacts
};
